import { Directive, ElementRef, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { SxMonitoringService } from 'app/services/sx-monitoring.service';

@Directive({
    selector: '[appTrackClick]',
    standalone: false
})
export class TrackClickDirective implements OnInit {
  public hostname = window.location.protocol + '//' + window.location.host;

  constructor(private el: ElementRef, private router: Router, private sxmonitoringService:SxMonitoringService) {}

  ngOnInit() {}

  @HostListener('click', ['$event'])
  public onClick(eleRef) {
    const data = eleRef.currentTarget.getAttribute('sxaction');
    if (!data) {
      return;
    }
    console.log("Track click to analytics with data: " + data);  
    this.sxmonitoringService.logEvent(data);
  }

  
}
